import { stringToEnum } from '@snap-types/models/common';

export enum QuantityBasisSources {
  LAST_ORDER = 'LAST_ORDER',
  HIST_WORK_ORDER_ACT = 'HIST_WORK_ORDER_ACT',
  HIST_WORK_ORDER_EST = 'HIST_WORK_ORDER_EST',
  MASTER_EST = 'MASTER_EST',
  FIXED_PRICING = 'FIXED_PRICING',
  LAST_QUOTE = 'LAST_QUOTE',
  CONFIG_DEFAULT = 'CONFIG_DEFAULT',
}

export const quantityBasisSourcesSchema = stringToEnum(QuantityBasisSources);

export enum DisplayMagnitude {
  ONES = 'ONES',
  THOUSANDS = 'THOUSANDS',
}

export const displayMagnitudeSchema = stringToEnum(DisplayMagnitude);
